import React, { version } from "react";
import {
  Row,
  Col,
  Space,
  Image,
  message,
  Button,
  Modal,
  Form,
  Dropdown,
  Tooltip,
  Input,
  Avatar,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined, DownCircleOutlined, DownOutlined } from "@ant-design/icons";
import { CarOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import FairDetailsStore from "../store/FareDetailsStore";
import FareDetailsAdd from "./FareDetailsAdd";
import dayjs from "dayjs";
import AssignZoneToFare from "./AssignZoneToFare";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { is } from "date-fns/locale";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 230;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 140;
    } else if (val.title?.length > 8) {
      val.width = 130;
    } else {
      val.width = 90;
    }
  });

  return arr;
};

class FareDetails extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.fareDetailsStore = new FairDetailsStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openFareDetailsForm: false,
      addVersionModal: false,
      openAssignZoneForm: false,
      parameterId: "",
      assignParameterId: "",
      assignData: {},
      openDeleteModal: false,
      deleteData: {},
      editData: {},
      isDownload: true,
      version: "",
    };

    this.columns = widthAdderFunc([
      {
        title: context.translate("_COMPANY_NAME_"),
        dataIndex: "name",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("fareDetails") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_VEHICLE_TYPE_"),
        dataIndex: "vehicleType",
        width: 7,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_TARIFF_NAME_"),
        dataIndex: "tariffName",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_BASIC_FARE_"),
        dataIndex: "basicFare",
        width: 7,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_MINIMUM_FARE_"),
        dataIndex: "minFare",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DISTANCE_FARE_"),
        dataIndex: "distanceFare",
        width: 7,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_TIME_FARE_"),
        dataIndex: "timeFare",
        width: 7,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_VALID_FROM_DATETIME_"),
        dataIndex: "fromDate",
        width: 11,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        title: context.translate("_VALID_TO_DATETIME_"),
        dataIndex: "toDate",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        title: context.translate("_WORKING_DAYS_"),
        dataIndex: "peakTimeDays",
        width: 8,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          const daysList = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];

          const daysValues = val?.split(",");

          const dayNames = daysValues?.map((index) => daysList[index]);

          return dayNames?.join(", ");
        },
      },
      {
        title: context.translate("_FAIR_TYPE_"),
        dataIndex: "fairType",
        width: 6,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val === "1") {
            return <>Normal</>;
          } else if (val === "2") {
            return <>Holiday</>;
          }
        },
      },
      {
        title: context.translate("_TAX_PERCENTAGE_"),
        dataIndex: "taxPercentage",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_BOOKING_CHARGES_"),
        dataIndex: "bookingCharges",
        width: 9,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 5,
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Delete Record"
                    title={context.translate("_DELETE_RECORD_")}
                    color={config.tooltipColorDelete}
                  >
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Tooltip>
                </DeleteConfirm>
                */}

                <Tooltip
                  placement="bottom"
                  title={context.translate("_DOWNLOAD_TARIFF_")}
                  color={config.tooltipColorEdit}
                >
                  <DownCircleOutlined
                    style={{ fontSize: "15px", marginTop: "5px" }}
                    onClick={(e) => {
                      this.formRef.current?.resetFields();

                      this.setState({ addVersionModal: true, fareId: record.parameterId, crc32Value: "", version: "" });
                      this.getVersion();
                    }}
                  />{" "}
                </Tooltip>
                <Tooltip
                  placement="bottom"
                  title={context.translate("_ASSIGN_ZONE_")}
                  color={config.tooltipColorEdit}
                >
                  <CarOutlined
                    style={{ fontSize: "15px", marginTop: "5px" }}
                    onClick={(e) => {
                      this.setState({
                        openAssignZoneForm: true,
                        assignParameterId: record.parameterId,
                        assignData: record,
                      });
                    }}
                  />{" "}
                </Tooltip>
                {this.props.canDelete("fareDetails") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
                <Dropdown
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer" }}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>
              </Space>
            </>
          );
        },
      },
    ]);
    this.actionColumn = {
      items: [
        this.props.canUpdate("fareDetails") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
                onClick={() => this.onEdit(this.state.editData)}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
          // icon: (

          // ),
        },
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_DOWNLOAD_"),
          key: "download",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={downloadIcon}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (val.key == "download") {
          this.formRef.current?.resetFields();

          this.setState({ addVersionModal: true, fareId: "", isDownload: true, crc32Value: "", version: "" });
          this.getVersion();

        }
      },
    };
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setFareDetailsData = this.context.viewStateStore.fareDetailsObject;

      setFareDetailsData =
        typeof setFareDetailsData === "number"
          ? setFareDetailsData
          : setFareDetailsData.companyId;

      if (setFareDetailsData !== "") {
        await this.fareDetailsStore.loadData({
          companyId: setFareDetailsData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setFareDetailsData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setFareDetailsData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setFareDetails({
      companyId: record.companyId,
    });
    await this.setState({ parameterId: record.parameterId });
    await this.setState({ openFareDetailsForm: true });
  };

  async onDelete(record) {
    const response = await this.fareDetailsStore.deleteRecord({
      parameterId: record.parameterId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.fareDetailsStore.loadData({
      companyId: this.state.companyId,
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      page: this.state.currentPage,
    });
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openFareDetailsForm: false });
  };

  closeAssignZoneModal = () => {
    this.setState({ openAssignZoneForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openFareDetailsForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };
  handleAddVersionForm = async (values) => {
    this.formRef.current?.resetFields();
    this.setState({ addVersionModal: false, version: "", crc32Value: "", isDownload: true });
  };

  handleModalClose = () => {
    this.setState({ addVersionModal: false }, () => {
      this.formRef.current?.resetFields();
    });
  };
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.fareDetailsStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  getVersion = async () => {
    console.log("companyId", this.state.companyId)
    const data = await this.fareDetailsStore.getVersion({
      companyId: this.state.companyId,
    });
    console.log("version", data)
    this.formRef.current?.setFieldsValue({ version: data.version })

    this.setState({ version: data.version });
  };
  generateCRC32 = async () => {
    const data = await this.fareDetailsStore.generateCRC32({
      companyId: this.state.companyId,
      version: this.formRef.current?.getFieldValue("version"),
    })
    console.log(data.crc32Value)
    this.formRef.current?.setFieldsValue({ crc32Value: data.crc32Value })
    this.setState({ isDownload: false })
  };
  downloadJson = async () => {
    const companyId = this.state.companyId;
    const fareId = this.state.fareId
    await this.fareDetailsStore.downloadJson(companyId, fareId)
    this.setState({ addVersionModal: false, fareId: "", version: "", crc32Value: "", isDownload: true })
  }
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "30px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.ExportMenuProps}
                >
                  <Image
                    style={{ height: 18, alignItems: "center" }}
                    src={kebabIcon}
                  ></Image>
                </Dropdown>

                {this.props.canCreate("fareDetails") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        openFareDetailsForm: true,
                        parameterId: "",
                      })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.fareDetailsStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.fareDetailsStore?.taxiParameterList}
            loading={this.fareDetailsStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openFareDetailsForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openFareDetailsForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_TAXI_PARAMETERS_")}
                <p className="formDescription">
                  {this.context.translate("_FARE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openFareDetailsForm: false })}
            onCancel={() =>
              this.setState({ openFareDetailsForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <FareDetailsAdd
                parameterId={this.state.parameterId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        <Modal
          width={400}
          // title={this.context.translate("_ADD_VERSION_")}
          title={
            <div className="deleteModalTitle">
              <span> {this.context.translate("_ADD_VERSION_")}</span>
              <CloseOutlined
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.handleModalClose()}
              // onClick={() => this.setState({ addVersionModal: false })}
              />
            </div>
          }
          className="addDeptModal"
          open={this.state.addVersionModal}
          onCancel={() => this.setState({ addVersionModal: false })}
          footer={null}
          closable={false}
        >
          <Form
            layout="vertical"
            ref={this.formRef}
            onFinish={this.handleAddVersionForm}
          >
            <Form.Item
              // label={this.context.translate("_VERSION_")}
              className="uploadCompany"
              name="version"
              label={
                <span>
                  {this.context.translate("_VERSION_")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              required={false}
              rules={[
                {
                  required: true,
                  message: `${this.context.translate(
                    "_VERSION_"
                  )} ${this.context.translate("_IS_REQUIRED_")}`,
                },
              ]}
            >
              <Input></Input>
            </Form.Item>

            <Form.Item
              // label="CRC32"
              name="crc32Value"
              label={
                <span>
                  CRC32
                  {/* <span style={{ color: "red" }}>*</span> */}
                </span>
              }
            // required={false}
            // rules={[
            //   {
            //     required: true,
            //     message: `CRC32 ${this.context.translate("_IS_REQUIRED_")}`,
            //   },
            // ]}
            >
              <Input value={this.state.crc32Value} disabled></Input>
            </Form.Item>

            <div className="addDeptModalButtons">
              <Button
                className="addDeptModalOkButton"
                // htmlType="submit"
                onClick={this.generateCRC32}
              // loading={this.state.loading}
              >
                Generate CRC32
              </Button>

              <Button className="addDeptModalOkButton" onClick={this.downloadJson} disabled={this.state.isDownload}>
                {this.context.translate("_DOWNLOAD_")}
              </Button>
            </div>
          </Form>
        </Modal>

        {this.state.openAssignZoneForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   // title="Rule Details"
          //   title={this.context.translate("_ASSIGN_ZONE_")}
          //   centered
          //   open={this.state.openAssignZoneForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openAssignZoneForm: false });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openAssignZoneForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ASSIGN_ZONE_")}
                <p className="formDescription">
                  {this.context.translate("_ASSIGN_ZONE_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openAssignZoneForm: false })}
            onCancel={() => this.setState({ openAssignZoneForm: false })}
          >
            <div height="100%">
              <AssignZoneToFare
                companyId={this.state.companyId}
                parameterId={this.state.assignParameterId}
                assignData={this.state.assignData}
                closeModal={this.closeAssignZoneModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
FareDetails.contextType = StoreContext;
export default observer(withRouter(FareDetails));
